// extracted by mini-css-extract-plugin
export default {"container":"LoadingIndicator_container__onQdX","message":"LoadingIndicator_message__trAlY"};